import script from "./MallShippingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallShippingPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallShippingPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__